import { render, staticRenderFns } from "./withdrawNew.vue?vue&type=template&id=ca2b3b64&scoped=true&"
import script from "./withdrawNew.vue?vue&type=script&lang=js&"
export * from "./withdrawNew.vue?vue&type=script&lang=js&"
import style0 from "./withdrawNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./withdrawNew.vue?vue&type=style&index=1&id=ca2b3b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b3b64",
  null
  
)

component.options.__file = "withdrawNew.vue"
export default component.exports